import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import {
  getToken,
  removeToken,
  setToken
} from './auth'
import commons from './commons'
console.log(window.$config.server)

const myheader = 'token'

// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? window.$config.server : 'http://localhost:1000',
  timeout: 120000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  config.headers[myheader] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Message.error({
    message: '请求超时!'
  })
  return Promise.resolve(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    console.log(response)
    if (response.headers[myheader]) {
      setToken(response.headers[myheader])
    }
    const res = response.data
    if (res.errcode !== '0x0000') {
      Message({
        message: res.errmsg,
        type: 'error',
        duration: 1 * 1000
      })
      // 0x0004:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.errcode === '0x0004' && getToken()) {
        removeToken()
        MessageBox.alert('你登陆时间已到期，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          callback: action => {
            commons.toLogin()
            // router.push({
            //   path: '/login'
            // })
          }
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js